<div class="se-dicom-popup">
    <div class="dialog-container">
        <div class="se-dialog-header mat-elevation-z6 se-dialog-header-warning">
            <h3 style="margin: 0" translate>Warning</h3>
        </div>
        <div class="se-dialog-content">
            <div style="flex: 1"></div>
            <p class="se-warning-message-text">{{ messageBoxText }}</p>
            <div style="flex: 1"></div>
            <div style="display: flex; flex-direction: row-reverse">
                <button
                    (click)="_onClickDialog('cancel')"
                    color="primary"
                    mat-button
                    style="font-size: 1em; margin: 10px"
                    type="button"
                >
                    <p style="margin: 0" translate>No</p>
                </button>
                <button
                    (click)="_onClickDialog('import')"
                    color="primary"
                    mat-button
                    style="font-size: 1em; margin: 10px"
                    type="button"
                >
                    <p style="margin: 0" translate>Yes</p>
                </button>
            </div>
        </div>
    </div>
</div>
